import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { keaSignInWithSecret } from 'actions/Auth';
import { switchLanguage } from 'actions/App';
import { useRouteMatch, useLocation } from 'react-router-dom';
import qs from 'qs';
import { CLOUD_IFRAME_START_MODE, setStartMode } from '../../util/appUtils';
import { applyLocaleFromQueryParam } from '../../util/localeStorage';

const SignInEmbedded = () => {
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const location = useLocation();

  const submitLogin = (domain, secret, appId) => (
    dispatch(keaSignInWithSecret(domain, secret, appId))
  );

  const applyLanguageFromQuery = () => {
    const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
    const langParam = queryParams.lang || queryParams.language;
    const localeConfig = applyLocaleFromQueryParam(langParam);

    if (localeConfig) {
      dispatch(switchLanguage(localeConfig));
    }
  };

  useEffect(() => {
    const { secret, domain, app } = match.params;
    applyLanguageFromQuery();
    if (secret && domain) {
      setStartMode(CLOUD_IFRAME_START_MODE);
      submitLogin(domain, secret, app);
    }
  }, []);

  return (
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3"
    >
      <div className="loader-view">
        <CircularProgress />
      </div>
    </div>
  );
};

export default SignInEmbedded;
